import { extractErrorMessage } from '@/utilities/common'
import { mapState } from 'vuex'
import PaymentGeneralMixin from 'mixins/payment-general'

export default {
  mixins: [PaymentGeneralMixin],

  computed: {
    ...mapState('account', {
      hasPaymentProfile: state => state.paymentDetails.hasPaymentProfile
    })
  },

  methods: {
    fetchMyPaymentMethod () {
      this.$store.dispatch('account/fetchMyPaymentMethod').then(() => {
        this.isLoading = false
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    }
  }
}
